<template>
<transition name="fade">
        <button id="skip" @click="skipVideo">Passer</button>
</transition>

</template>
<script>
    export default {
        name: 'SkipVideo',
        methods: {
            skipVideo() {
                this.$parent.video.currentTime = 391;
                $('#skip').hide()
            }
        }
    }
</script>
<style lang="scss" scoped>
    #skip {
        border: 1px solid #fff;
        background-color: transparent;
        color: #fff;
        padding: 20px 40px;
        border-radius: 50px;
        font-size: 1rem;
        position: fixed;
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
        cursor: pointer;
        outline: none;
        overflow: hidden;
        bottom: 5%;
        right: 5%;
        &:hover {
            background-color: #2235a1;
            border: 1px solid #2235a1;
            color: #fff;
        }
    }
</style>